import { useEffect } from 'react';
import useApiEndpoints from '../context/useApiEndpoints';
import useApi from './useApi';
import { CargoTemperatureLogDateBM } from '../types/BusinessModel/CargoTempLog/CargoTemperatureLogDateBM';
import { mapCargoTempLogDates } from '../factory/CargoTempLog/CargoTempLogDateFactory';
import { buildQueryParams } from './endpoints/queryParamsHelper';
import { createNoonReportStatusList } from '../factory/Aol//NoonReportStatusFactory';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';
import { NoonReportStatus } from 'src/types/ViewModel/Aol/NoonReportStatus';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { state, getApiData } = useApi();

    const getLatestNoonReportStatuses = async (
        imoNumber: number,
        fromDate: string,
        toDate: string,
        forceRefreshCache?: boolean
    ): Promise<NoonReportStatus[] | undefined> => {
        const result = await getApiData({
            endpoint: apiEndpoints['getNoonReportStatuses'].url,
            queryParam: buildQueryParams({ imoNumber, fromDate, toDate }),
            forceRefreshCache,
        });

        if (Array.isArray(result)) return createNoonReportStatusList(result);
    };

    const getLatestCargoTempLogDates = async (imoNumber: number, fromDate: string, toDate: string) => {
        const result = await getApiData({
            endpoint: apiEndpoints['getLatestCargoTempLogDates'].url,
            queryParam: buildQueryParams({ imoNumber, fromDate, toDate }),
            additionalInfo: { hideLoader: true },
            callInBackground: true,
        });

        if (Array.isArray(result)) {
            const bms = result as CargoTemperatureLogDateBM[];
            const logDates = mapCargoTempLogDates(bms);
            return logDates;
        }
    };

    const getLatestRobStatuses = async (imoNumber: number, fromDate: string, toDate: string) => {
        const result = await getApiData({
            endpoint: apiEndpoints['getRobStatusForShip'].url,
            queryParam: buildQueryParams({ imoNumber, fromDate, toDate }),
        });

        if (Array.isArray(result)) {
            const missingPortCallRobs = result as number[];
            return missingPortCallRobs;
        }
    };

    useEffect(() => {
        processApiEndpointError(state);
    }, [state]);

    return {
        state,
        getLatestCargoTempLogDates,
        getLatestNoonReportStatuses,
        getLatestRobStatuses,
    };
};
